import { Divider } from '@material-ui/core'

type BorderType = 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden'

interface ICustomDividerProps {
  color: string
  thickness: string
  borderType: BorderType
}

export const CustomDivider = ({ color, thickness, borderType }: ICustomDividerProps) => {
  return <Divider style={{ borderBottom: `${thickness} ${borderType} ${color}` }} />
}
